import React from "react";
import { pageData } from "./markup";
import Index from "../index";

export default ({ location }) => {
  return (
    <Index
      classname={"beta"}
      pageData={pageData}
      location={location.pathname}
      props={location.state}
    />
  );
};
